module.exports = __webpack_public_path__ + "img/bot_shdj.b9f80077.png";